const STYLES = {
  AI: "bg-blue-50 text-blue-700 border-blue-100",
  SaaS: "bg-purple-50 text-purple-700 border-purple-100",
  Marketplace: "bg-orange-50 text-orange-700 border-orange-100",
  Subscription: "bg-green-50 text-green-700 border-green-100",
  Freemium: "bg-emerald-50 text-emerald-700 border-emerald-100",
  B2B: "bg-indigo-50 text-indigo-700 border-indigo-100",
  B2C: "bg-pink-50 text-pink-700 border-pink-100",
  Global: "bg-teal-50 text-teal-700 border-teal-100",
  "High Growth": "bg-red-50 text-red-700 border-red-100",
  "E-commerce": "bg-amber-50 text-amber-700 border-amber-100",
};

export const Badges = ({ items = [], className = "" }) => (
  <div className={`flex flex-wrap gap-2 ${className}`} data-testid="business-badges">
    {items.map((b) => (
      <span
        key={b}
        className={`text-xs font-semibold px-3 py-1 rounded-full border ${STYLES[b] || "bg-gray-50 text-gray-600 border-gray-100"}`}
      >
        {b}
      </span>
    ))}
  </div>
);

const DIFF = {
  Easy: "bg-green-500",
  Medium: "bg-[#D4AF37]",
  Hard: "bg-red-500",
};

export const DifficultyPill = ({ level }) => (
  <span className="inline-flex items-center gap-2 text-sm font-medium text-[#0F0F0F]" data-testid="difficulty-pill">
    <span className={`w-3 h-3 rounded-full ${DIFF[level] || "bg-gray-400"}`} />
    {level}
  </span>
);
